import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableRowColumn } from 'material-ui/Table';
import { tableActionColumnStyles } from '../styles';
import CancelFuelCard from '../cancel-fuel-card';
import ActivityStatus from '../activity-status';

const FuelCardTableRow = ({
  fuelCard,
  onCancel,
  loadingAction,
  disableAction
}) => (
  <TableRow>
    <TableRowColumn>#{fuelCard.fuelCardNumber}</TableRowColumn>
    <TableRowColumn>{fuelCard.provider}</TableRowColumn>
    <TableRowColumn>{fuelCard.registration}</TableRowColumn>
    <TableRowColumn>
      <ActivityStatus status={fuelCard.status} />
    </TableRowColumn>
    <TableRowColumn>{fuelCard.issuedDate}</TableRowColumn>
    <TableRowColumn style={tableActionColumnStyles}>
      <CancelFuelCard
        loading={loadingAction}
        disabled={disableAction}
        onClick={() => {
          onCancel(fuelCard);
        }}
      />
    </TableRowColumn>
  </TableRow>
);

FuelCardTableRow.defaultProps = {
  onCancel: () => {},
  disableAction: false,
  loadingAction: false
};

FuelCardTableRow.propTypes = {
  /**
   * The fuel card which will be displayed for this table row
   */
  fuelCard: PropTypes.object.isRequired,

  /**
   * Action to call when a user clicks the Cancel Card column
   */
  onCancel: PropTypes.func,

  /**
   * True if the cancel action should be in a loading state
   */
  loadingAction: PropTypes.bool,

  /**
   * True if the cancel action should not be interactable
   */
  disableAction: PropTypes.bool
};

export default FuelCardTableRow;



// WEBPACK FOOTER //
// ./src/features/fuel-cards/fuel-card-table/fuel-card-table-row.js